import gql from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';

import { PartialAsset } from '@libs/types';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';

export type NestedAssetNew = PartialAsset & {
  pairedAssets?: PartialAsset[];
};

export type ExchangeSettingsV2Args = {
  onlyCrypto?: boolean;
  assetCode?: string;
};

export type GetExchangeSettingsV2Response = {
  getExchangeSettingsV2: DefaultApiResponse<NestedAssetNew[]>;
};
export const getExchangeSettingsV2: TypedDocumentNode<
  GetExchangeSettingsV2Response,
  DefaultArg<ExchangeSettingsV2Args>
> = gql`
  query getExchangeSettingsV2($record: GetExchangeSettingsRecord!) {
    getExchangeSettingsV2(record: $record) {
      code
      iconUrl
      isStable
      name
      roundingPrecision
      pairedAssets {
        roundingPrecision
        name
        isStable
        isCrypto
        iconUrl
        code
      }
    }
  }
`;
